import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useStringMap } from "../../utilities/string-map/useStringMap";
import { ScreenReaderContent } from "../../screen-reader-content/ScreenReaderContent";
import * as StyledBack from "./SelectBackOption.styled";
import { stringMapDefault } from "./Select.stringMap";
export const SelectBackOption = forwardRef(({ closeAndReturnFocus, hasCheckboxes, isSearchable, label, parentId, onClick, 
// FIXME: This is actually required despite being deprecated
overlayRef, stringMap: stringMapProp, searchText, 
// Deprecated but supported
toggleRef, setIsOpen, ...otherProps }, ref) => {
    const stringMap = useStringMap("Select", { stringMapDefault, stringMapProp });
    const sendFocusBack = () => {
        requestAnimationFrame(() => {
            if (overlayRef && overlayRef.current) {
                const wrapperSelector = hasCheckboxes ? `ul[role="group"]` : `ul[role="listbox"]`;
                const parentButton = overlayRef.current.querySelector(`${wrapperSelector} [data-id="${parentId}"]`);
                if (parentButton) {
                    parentButton.focus();
                }
            }
        });
    };
    const handleKeyDown = (event) => {
        // TODO: ArrowLeft should work on any item, not just the Back item (DES-3280)
        if (event.key === "ArrowLeft" || event.key === " " || event.key === "Enter") {
            event.preventDefault();
            onClick && onClick();
            sendFocusBack();
        }
        else if (!hasCheckboxes && event.key === "Tab") {
            if (closeAndReturnFocus) {
                event.preventDefault();
                closeAndReturnFocus();
            }
            else if (setIsOpen && toggleRef?.current) {
                // TODO: remove in the next major along with overlayRef-based logic
                event.preventDefault();
                setIsOpen(false);
                toggleRef.current.focus();
            }
        }
    };
    const handleClick = (event) => {
        event.stopPropagation();
        onClick && onClick();
        sendFocusBack();
    };
    const { back: backLabel } = stringMap;
    // This is a bit of a hack - but in some cases this component will have the word "Back" displayed visually
    // whereas in other cases it will have the name of the parent option displayed visually.
    // In the former case, we will avoid having the screen reader read "Back" twice in a row.
    const iconLabel = backLabel === label ? undefined : backLabel;
    const labelToRender = typeof label === "function" ? label({ searchText }) : label;
    return (_jsxs(StyledBack.BackOptionItem, { ref: ref, role: hasCheckboxes ? undefined : "option", hasCheckboxes: hasCheckboxes, isFirst: !isSearchable && !hasCheckboxes, "data-testid": "SelectBackOption", tabIndex: hasCheckboxes ? 0 : -1, palette: "interactiveConstructive", isNested: true, onClick: handleClick, onKeyDown: handleKeyDown, "data-select-item": true, ...otherProps, children: [_jsx(StyledBack.BackIcon, { palette: "structural", size: 16, "aria-hidden": true }), _jsx(ScreenReaderContent, { children: iconLabel }), _jsx("span", { id: hasCheckboxes ? undefined : `${parentId}-label`, children: labelToRender })] }));
});
SelectBackOption.displayName = "SelectBackOption";
SelectBackOption.defaultProps = {
    label: "Back"
};
